import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { User, LanguageSelector } from 'components/shared';
import * as S from './styles';
import { usePermissions, useTranslation } from 'hooks';
import { translations } from './translations';

interface IModule {
  icon: any;
  name: string;
  description: string;
  active: boolean;
  innerUrl?: string;
  url?: string;
}

const hostname = window.location.hostname;

const getEnvironment = () => {
  if (hostname === 'localhost') {
    return 'http://localhost:3000/base/';
  }

  if (hostname === 'helm.webcol.systems') {
    return 'https://helm.webcol.systems/';
  }

  if (hostname === 'hml-helm.webcol.systems') {
    return 'https://hml-helm.webcol.systems/';
  }

  return 'https://helm.webcol.systems/';
};

const baseUrl = getEnvironment();

export const AsideMenu: React.FC = () => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const { getTranslation } = useTranslation(translations);
  const isHomolog = hostname === 'hml-helm.webcol.systems' ? true : false;

  const modules: IModule[] = [
    {
      icon: <S.IconControlTower />,
      name: getTranslation('controlTower'),
      description: getTranslation('descControlTower'),
      active: checkUserPermission('accessControlTower'),
      innerUrl: '/control-tower',
    },
    {
      icon: <S.IconTracking />,
      name: getTranslation('Tracking'),
      description: getTranslation('descTracking'),
      active: checkUserPermission('accessTracking'),
      url: baseUrl + 'tracking/',
    },
    // {
    //   icon: <S.IconSchedule />,
    //   name: getTranslation('agendamento'),
    //   description: getTranslation('descAgendamento'),
    //   // active: checkUserPermission('accessScheduling'),
    //   active: false,
    //   url: baseUrl + 'agendamento/',
    // },
    // {
    //   icon: <S.IconCheckFreight />,
    //   name: getTranslation('CheckFretes'),
    //   description: getTranslation('descCheckFretes'),
    //   active: checkUserPermission('accessCheckFreights'),
    //   url: baseUrl + 'checkfrete/',
    // },
    // {
    //   icon: <S.IconRouter />,
    //   name: getTranslation('roterizador'),
    //   description: getTranslation('descRoterizador'),
    //   active: checkUserPermission('accessScripter'),
    //   // active: false,
    //   url: 'https://main.d17tbaouxuwej3.amplifyapp.com/consolidador',
    // },
    {
      icon: <S.IconSettings />,
      name: getTranslation('configurador'),
      description: getTranslation('descConfigurador'),
      active: checkUserPermission('accessConfigurator'),
      innerUrl: '/settings',
    },
  ];

  const handleNavigation = useCallback(
    (module: IModule) => {
      if (module.active) {
        if (module.innerUrl) return history.push(module.innerUrl);
        if (module.url) return window.open(module.url);
      }
    },
    [history]
  );

  return (
    <S.Container>
      <S.Content>
        <S.Logo onClick={() => history.push('/')} />
        <LanguageSelector />
        <User />
        {modules.map((module) => (
          <S.ButtonModule
            active={module.active}
            onClick={() => handleNavigation(module)}
            key={module.innerUrl || module.url}
          >
            <S.ModuleTitle isHomolog={isHomolog}>
              {module.icon}
              {module.name}
            </S.ModuleTitle>
            <S.ModuleDescription>{module.description}</S.ModuleDescription>
          </S.ButtonModule>
        ))}
      </S.Content>
    </S.Container>
  );
};
